import { getProperty } from '@/utils/object'

/**
 * @tutorial
 * @see https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
  for (let index = array.length - 1; index > 0; index--) {
    const randomNumber = Math.floor(Math.random() * (index + 1))

    ;[array[index], array[randomNumber]] = [array[randomNumber], array[index]]
  }

  return array
}

/**
 * Returns true if the given array is empty or doesn't exist.
 *
 * @param {Array|undefined} array
 * @return {boolean}
 */
export function isEmptyArray(array) {
  return !array || array.length === 0
}

/**
 * Returns a clone of the given array sorted by the given key and optional method.
 * If no method is given, numeric sorting is applied.
 *
 * @param {Array<Object>} array
 * @param {string} key
 * @param {function(*,*):Number} method
 * @return {Array<Object>}
 */
export function sortBy(array, key, method = (a, b) => a - b) {
  return array.sort((a, b) => method(getProperty(a, key), getProperty(b, key)))
}
